var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.canLoadMore)?_c('div',{staticClass:"hiq-search-app__load-more"},[_c('button',{staticClass:"hiq-search-app__load-more--button hiq-load-more",on:{"click":_vm.loadMore}},[_vm._v(_vm._s(_vm.translations.loadMore))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }